export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: ComicCategory[] = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '燃爆青春的热血战斗漫画，点燃你的激情与梦想' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的日常漫画，让你笑到停不下来' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱漫画，感受心动每一刻' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '脑洞大开的科幻漫画，探索宇宙与未来世界' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理漫画，层层谜团等你揭开' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', description: '宏大的玄幻世界，修真炼气纵横天下' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', description: '都市生活的精彩漫画，职场与日常百态' },
  { slug: 'xiaoyuan', name: '校园', icon: 'ri-book-open-line', description: '青春活力的校园漫画，回忆美好的学生时代' },
];

export const categoryMap: Record<string, ComicCategory> = {};
categories.forEach((cat) => { categoryMap[cat.slug] = cat; });